import React, { useState, Fragment, useEffect } from "react";
import { Route } from "react-router-dom";
import { Formik, Form } from "formik";
import Main from "../Main/main";
// Utils de las notificaciones
import {
  GenerarSubcripcion,
  enviarSubscripcion,
} from "../../utils/Notificaciones";

import logo from "../../images/logo.png";
import en from "../../images/english.png";
import es from "../../images/spanish.png";

import { text } from "../../utils/Multilanguage";

import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import DialogSignatureMechanic from "../DialogSignatureMechanic/DialogSignatureMechanic";

import { Button, Snackbar } from "@material-ui/core";
import MuiAlert from "@material-ui/lab/Alert";
import "../../index.css";
import Axios from "axios";
import Signature from "../Signature/Signature";
import CustomDialog from "../CustomDialog/CustomDialog";
import config from "../../config";
function Alert(props) {
  return <MuiAlert elevation={6} variant='filled' {...props} />;
}

export default function Login(props) {
  //Hooks
  const [setting, setSetting] = useState({
    isLogged: false,
    hidden: true,
    language: props.language,
    server: config.API_URL,
  });
  const [isOffline, setIsOffline] = useState(navigator.onLine);
  const [errorSnackbar, setErrorSnackbar] = useState({
    isOpen: false,
    message: "Error",
  });
  const [open, setOpen] = useState(false);
  const [result, setResult] = useState({
    token: "",
    user_email: "",
    user_name: "",
    user_idDriver: 0,
    key: "",
  });
  const [isloading, setIsLoading] = useState(false);
  const [response, setResponse] = useState(null);

  useEffect(() => {

    if (response) {
      if (response.user.idDriver) {
        localStorage.setItem("token", response.accessToken);
        localStorage.setItem("email", response.user.emailAddress);
        localStorage.setItem("name", response.user.fullName);
        localStorage.setItem("user_id", response.userId);
        localStorage.setItem("user_idDriver", response.user.idDriver);
        localStorage.setItem("key", response.user.key);

        setResult({
          token: response.accessToken,
          user_email: response.user.emailAddress,
          user_name: response.user.fullName,
          user_idDriver: response.user.idDriver,
          key: response.user.key,
        });

        try {
          if (Notification.permission === "granted") {
            GenerarSubcripcion().then((result) => {
              enviarSubscripcion(result, response.accessToken);
            })
          }
        } catch (error) {
          console.log(error);
        }

        setSetting({
          ...setting,
          isLogged: true,
        });
      } else {
        setErrorSnackbar({
          isOpen: true,
          message: "this user is not a driver",
        });
        setIsLoading(false);
      }
    }
  }, [response]);


  window.addEventListener("offline", () => {
    setIsOffline(false);
    setOpen(true);
  });

  window.addEventListener("online", () => {
    setIsOffline(true);
    setOpen(false);
  });

  const changeLanguage = (e) => {
    if (setting.language === "en") {
      setSetting({
        ...setting,
        language: "es",
      });
      localStorage.setItem("language", "es");
    } else {
      setSetting({
        ...setting,
        language: "en",
      });
      localStorage.setItem("language", "en");
    }
  };

  const toggleShow = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setSetting({
      ...setting,
      hidden: !setting.hidden,
    });
  };

  const handleClose = (event, reason) => {
    if (reason === "timeout") {
      setErrorSnackbar({ ...errorSnackbar, isOpen: false });
    }
  };

  if (!setting.isLogged) {
    return (
      <div
        className='container_login'
        style={{ width: "100%", height: "100%" }}
      >
        <Formik
          initialValues={{
            userNameOrEmailAddress: "",
            password: "",
            isPwa: true,
          }}
          onSubmit={async (values, onSubmitProps) => {
            setErrorSnackbar({
              isOpen: false,
              message: "",
            });

            if (navigator.onLine && values.userNameOrEmailAddress !== "" && values.password !== "") {
              setIsLoading(true);

              try {
                const response = await Axios.post(`${setting.server}TokenAuth/Authenticate`, values, {
                  headers: {
                    "Abp.TenantId": config.TENANT_ID,
                  }
                });
                console.log(response);
                if (response.status === 200) {
                  setIsLoading(false);
                  setResponse(response.data.result);
                }
              } catch (err) {
                setErrorSnackbar({
                  isOpen: true,
                  message: "Invalid user name or password",
                });
                setIsLoading(false);
              }

            } else {
              setErrorSnackbar({ isOpen: true, message: "Required field" });
            }

          }}
          render={({ handleSubmit, setFieldValue }) => {
            return (
              <Form
                className='white'
                style={{ width: "100%", height: "100%" }}
                onSubmit={handleSubmit}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    paddingTop: 10,
                  }}
                >
                  <img
                    src={setting.language === "en" ? es : en}
                    alt=''
                    style={{ width: 30, height: 30 }}
                    onClick={changeLanguage}
                  />
                </div>
                <div className='input-field'>
                  <label htmlFor='userNameOrEmailAddress'>{text("Email")}</label>
                  <input
                    type='text'
                    name='userNameOrEmailAddress'
                    className='validate'
                    onChange={(event) => {
                      setFieldValue(event.target.name, event.target.value);
                    }}
                  />
                </div>
                <div className='input-field'>
                  <label htmlFor='password'>{text("Password")}</label>
                  <input
                    type={setting.hidden ? "password" : "text"}
                    name='password'
                    className='validate'
                    onChange={(event) => {
                      setFieldValue(event.target.name, event.target.value);
                    }}
                  />
                  <div
                    className='password__show'
                    onClick={toggleShow}
                    style={{
                      position: "absolute",
                      bottom: "21px",
                      right: -10,
                      color: "gray",
                    }}
                  >
                    <i
                      className='material-icons left'
                      style={{ fontSize: "24px" }}
                    >
                      {setting.hidden ? "visibility_off" : "visibility"}
                    </i>
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    paddingTop: 10,
                  }}
                >
                  <div className='input-field '>
                    <Button
                      variant='contained'
                      color='primary'
                      type='submit'
                      disabled={!isOffline}
                    >
                      {text("Login")}
                    </Button>
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    paddingTop: 40,
                    opacity: 0.2,
                  }}
                >
                  <img
                    src={logo}
                    alt=''
                    style={{ width: "60%", height: "60%" }}
                  />
                </div>

                <LoadingSpinner isLoading={isloading} />
              </Form>
            );
          }}
        ></Formik>
        <Snackbar open={open} autoHideDuration={6000}>
          <Alert severity='error'>
            {text("You are not connected to any network")}
          </Alert>
        </Snackbar>
        <Snackbar
          open={errorSnackbar.isOpen}
          autoHideDuration={6000}
          onClose={handleClose}
        >
          <Alert severity='error'>{text(errorSnackbar.message)}</Alert>
        </Snackbar>
      </div>
    );
  } else {
    return (
      <Fragment>
        <div className='container-fluid'>
          <Route
            path='/'
            render={(props) => (
              <Main
                {...props}
                token={result.token}
                email={result.user_email}
                name={result.user_name}
                language={setting.language}
                idDriver={result.user_idDriver}
                authKey={result.key}
                label='home'
                debug={props.debug}
              />
            )}
          />
        </div>
      </Fragment>
    );
  }
}
